import {Dispatch} from "react-redux";
import {IActionsByTypedCommands} from "./secretCommands";
import {appMainChangeLocale, appShowEnglishWithCodesOption} from "../state/actions";

export const commandsSetup: IActionsByTypedCommands = {
	"###ttt": (dispatch: Dispatch<any>) => {
		dispatch(appShowEnglishWithCodesOption());
		dispatch(appMainChangeLocale("enUSCodes"));
	},
};